// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-12c07822]{list-style:none!important;margin:0!important;padding:0!important}", "",{"version":3,"sources":["webpack://./chat/vue/widget/ChatModalMenu.vue"],"names":[],"mappings":"AACA,oBACE,yBAAA,CAEA,kBAAA,CADA,mBACA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
